export default __webpack_public_path__ + "88e4f45bccd607f61ecaad63e4062cb3.png";